import { useRouter } from "@src/lib/router";
import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import BottomNotication from "@src/components/UIElements/BottomNotification";
import Footer from "@src/components/UIElements/Footer";
import { getAwsAssets } from "@src/utils";
import BuyNowFooter from "./BuyNowFooter";
import { installmentsAlertStateEnum } from "@src/components/Tabs/Overview/store/constants.js";
import { useTranslation } from "react-i18next";
import { TAB_BAR_ENUMS } from "@src/components/UIElements/TabBar/store/constants";
import { COURSE_TABS_ENUMS } from "@src/utils/constants";
import useTimer from "@src/customHooks/useTimer";
import formatSecondsToDHMS from "@src/utils/timeFormatter";
import { getTabListAction } from "@src/components/UIElements/TabBar/store/actions";

function LayoutFooter({
  getCourseCouponListStudentDataServer,
  overviewDataServer,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch()
  // ROUTER
  const router = useRouter();
  // SELECTORS
  const state = useSelector((state) => {
    if (state?.overviewReducer?.overViewDetails?.course?.details?.name) {
      return state?.overviewReducer?.overViewDetails?.course;
    } else return overviewDataServer?.course;
  });

  const showSuggestions = useSelector(
    (state) => state?.layoutReducer?.showSuggestions
  );

  const priorityOrderList = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.priorityOrderList
  );

  const loading = useSelector(
    (state) => state?.overviewReducer?.overViewDetailsLoading
  );

  const graphCourseCouponListData = useSelector(
    (state) => state?.overviewReducer?.graphCourseCouponListData
  );

  const graphCourseData = useSelector(
    (state) => state?.overviewReducer?.graphCourseData
  );
  
  const tabList = useSelector(
    (state) => state?.tabBarReducer?.tabList
  ) || [];
  const handleTrialExpiry = () => {
    router.push(`/${router.query.courseId}/${TAB_BAR_ENUMS.overview}`);
    dispatch(getTabListAction({ courseId: router.query.courseId }));
  }
  const trialTabData = tabList.find((tab) => tab.enumKey === COURSE_TABS_ENUMS.TRIAL_CONTENT);
  const timeLeft = useTimer(trialTabData?.tabAccessTimeLeftInSec, !router.isReady, handleTrialExpiry )
  let appliedCoupon = graphCourseData?.appliedCoupon;
  // console.log("graphCourseCouponListData", graphCourseCouponListData);
  // FOOTER CONDITION
  const checkForBuyNow = () => {
    // console.log("check");
    if (
      state?.installments?.paidInstallmentSummary?.isPaymentComplete === 0 &&
      state?.metaData?.isPurchased === 0
    ) {
      return false;
    } else if (
      state?.installments?.paidInstallmentSummary?.isPaymentComplete === 0 &&
      state?.metaData?.isPurchased === 1
    ) {
      return false;
    } else if (
      state?.installments?.paidInstallmentSummary?.isPaymentComplete === 1 ||
      state?.metaData?.isPurchased === 1
    ) {
      return true;
    } else if (state?.metaData?.isPurchased) {
      return true;
    }
    return false;
  };

  // FOOTER CONTENT
  const renderNotification = () => {
    if (appliedCoupon) {
      return (
        <>
          <BottomNotication
            icon={getAwsAssets("CouponList.svg", "Overview")}
            backgroundColor="#E8F7FF"
          >
            {appliedCoupon?.code} {t("layout.couponApplied", "coupon applied")}
          </BottomNotication>
          {(router.query?.tabId == TAB_BAR_ENUMS.overview ||
            router.query?.tabId == TAB_BAR_ENUMS.trialContent) &&
          trialTabData &&
          !trialTabData.isLocked && timeLeft ? (
            <BottomNotication
              icon={
                "https://cdn-wl-assets.classplus.co/frontend-assets/timer.svg"
              }
              backgroundColor="#EF691E" //orange
              textColor="#FFFFFF"
              marginTop={"2px"}
            >
              Your trial will end in {formatSecondsToDHMS(timeLeft)?.v1}
            </BottomNotication>
          ) : null}
        </>
      );
    } else if (
      state?.installments?.installmentAlertState ===
      installmentsAlertStateEnum.COURSE_LOCKED
    ) {
      return (
        <BottomNotication
          icon={getAwsAssets("NotificationStripClock.svg", "content")}
          backgroundColor="#FF4058"
          textColor="white"
        >
          Missed Due date:{" "}
          {state?.installments?.paidInstallmentSummary?.info?.[2]?.value?.text}
        </BottomNotication>
      );
    } else if (
      state?.installments?.installmentAlertState ===
      installmentsAlertStateEnum.DAYS_LEFT_EXPIRE
    ) {
      return (
        <BottomNotication
          icon={getAwsAssets("NotificationStripClock.svg", "content")}
          backgroundColor="#5AB369"
          textColor="white"
        >
          Due date:{" "}
          {state?.installments?.paidInstallmentSummary?.info?.[2]?.value?.text}
        </BottomNotication>
      );
    } else if (state?.returnFomo) {
      return (
        <BottomNotication
          icon={getAwsAssets("FOMOfire.svg", "content")}
          backgroundColor="#E8F7FF" //blue
          textColor="black"
        >
          {state?.returnFomo?.text}
        </BottomNotication>
      );
    } else if((router.query?.tabId == TAB_BAR_ENUMS.overview || router.query?.tabId == TAB_BAR_ENUMS.trialContent) && trialTabData && !trialTabData.isLocked){
      if(!timeLeft) return null;
      return (
        <BottomNotication
          icon={"https://cdn-wl-assets.classplus.co/frontend-assets/timer.svg"}
          backgroundColor="#EF691E" //orange
          textColor="#FFFFFF"
        >
          Your trial will end in {formatSecondsToDHMS(timeLeft)?.v1}
        </BottomNotication>
      )
    }
  };

  return checkForBuyNow() ? (
    priorityOrderList?.length && showSuggestions ? (
      <Footer />
    ) : null
  ) : state?.metaData?.id ? (
    <BuyNowFooter
      isInstallmentCompleted={
        state?.installments?.paidInstallmentSummary?.isPaymentComplete
      }
      isInstallment={state?.installments?.purchasedViaInstallment}
      buttonText={state?.installments?.installmentPaymentData?.purchaseText}
      getCourseCouponListStudentDataServer={
        getCourseCouponListStudentDataServer
      }
      isFreeCourse = {state?.metaData?.isFreeCourse || 0}
    >
      {renderNotification()}
    </BuyNowFooter>
  ) : null;
}

const MemoFooter = memo(LayoutFooter);

export default MemoFooter;
